import React from "react";
import { OVERVIEW } from "../../../../../core/theme/reportTheme";
import { useAccount } from "../../../../../core/hooks/useAccount";
import { canSeeAdtao } from "../../../../../core/data/account";

// Search volume, benchmarks and data used, in one row. These will carry more
// outside data later (Google Ads, benchmarks). Benchmarks are AdTao-derived,
// so they only show for an account allowed to see AdTao (canSeeAdtao).
export default function TopCards({ result }) {
  const showBenchmarks = canSeeAdtao(useAccount());
  return (
    <div className={showBenchmarks ? OVERVIEW.topRow : OVERVIEW.topRowTwo}>
      <SearchVolumeCard searchVolume={result.searchVolume} />
      {showBenchmarks && <BenchmarksCard />}
      <DataUsedCard sources={result.sources} showBenchmarks={showBenchmarks} />
    </div>
  );
}

function SearchVolumeCard({ searchVolume }) {
  return (
    <div className={OVERVIEW.dashedCard}>
      <p className={OVERVIEW.cardTitle}>{searchVolume.label}</p>
      <p className={`${OVERVIEW.cardText} mt-1`}>Google's estimate for these keywords across the area. Not available yet.</p>
      <button type="button" className={`${OVERVIEW.link} mt-1.5`}>Connect Google Ads for real impressions</button>
    </div>
  );
}

function BenchmarksCard() {
  return (
    <div className={OVERVIEW.dashedCard}>
      <p className={OVERVIEW.cardTitle}>Benchmarks</p>
      <p className={`${OVERVIEW.cardText} mt-1`}>How this market compares with others like it. Coming soon.</p>
    </div>
  );
}

function DataUsedCard({ sources, showBenchmarks }) {
  const { runs, searches } = sources.runningJobs;
  return (
    <div className={OVERVIEW.card}>
      <p className={OVERVIEW.cardTitle}>Data used</p>
      <div className="mt-1.5 text-xs">
        <SourceRow filled>
          <span className="text-slate-800">Your searches · {runs > 0 ? `${runs} run${runs === 1 ? "" : "s"} · ` : ""}{searches} searches</span>
        </SourceRow>
        <div className="flex items-start justify-between gap-2 mt-1.5">
          <SourceRow>
            <span className="text-slate-500">Google Ads · <button type="button" className={OVERVIEW.link}>connect</button></span>
          </SourceRow>
          {showBenchmarks && (
            <SourceRow>
              <span className="text-slate-500">Benchmarks</span>
            </SourceRow>
          )}
        </div>
      </div>
    </div>
  );
}

function SourceRow({ filled, children }) {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${filled ? "bg-slate-800" : "border border-dashed border-slate-400"}`} />
      {children}
    </div>
  );
}
